package modysy.tools

import modysy.GameController
import modysy.view.ImageProvider
import org.scalajs.dom.CanvasRenderingContext2D

/** Implements a tool for pushing agents inside the game world controlled
  * by the given GameController around.
  *
  * This tool temporary may be outside the game world.
  *
  * @param gameController the GameController controlling the game world
  */
class DeleteTool(gameController: GameController) extends Tool {

  /** Returns the non-negative amount of energy points needed to
    * use this tool once. This amount of points will be spent
    * using this tool once.
    *
    * @return energy cost to use this tool once
    */
  override def cost: Int = 0

  /** Renders the icon of this tool onto the given rendering context.
    * The icon is drawn with its center at (0, 0) so the context
    * need to be translated correctly.
    *
    * @param ctx context to render the icon on
    */
  override def renderIcon(ctx: CanvasRenderingContext2D): Unit = {
    ctx.save()
    ctx.scale(0.4, 0.4)
    ImageProvider
      .drawImgFnc(ImageProvider.getImage("nudge"), 110, 100)
      .apply(ctx, -(110 / 2), -(100 / 2))
    ctx.restore()
  }

  /** Renders the non-icon parts of this tool at the tools position set
    * by moveTo(...), moveBy(...) or even moveReset(...).
    * This may render nothing at all (e.g. is tool is not inside the game world).
    *
    * @param ctx context to render on
    */
  override def render(ctx: CanvasRenderingContext2D): Unit = {
    if (_position.isDefined) {
      ImageProvider
        .drawImgFnc(ImageProvider.getImage("nudge"), 110, 100)
        .apply(ctx, _position.get.x - 40, _position.get.y - 5)
    }
  }

  /** Uses this tool at the tools position set by moveTo(...) or moveBy(...).
    * The tool must be positioned somewhere in the game world before.
    *
    * Returns true if the tool was used successfully, otherwise false.
    *
    * @return Whether the interaction was successful.
    */
  override def use(): Boolean = {
    require(_position.isDefined, "called use() but NudgeTool not positioned")

    val items = gameController.getCollisionEngine
      .findOnPoint(_position.get)

    gameController.getObjects() --= items

    return true

  }

  override var uses: Int = 999
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/tools/DeleteTool.scala